import { render, staticRenderFns } from "./default-val-input.vue?vue&type=template&id=3a97994c&scoped=true&"
import script from "./default-val-input.vue?vue&type=script&lang=js&"
export * from "./default-val-input.vue?vue&type=script&lang=js&"
import style0 from "./default-val-input.vue?vue&type=style&index=0&id=3a97994c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97994c",
  null
  
)

export default component.exports